import React, { ReactElement } from 'react';
import { Grid } from '@material-ui/core';

interface IRowProps {
  widthInLargeScreen: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  children: ReactElement;
  style: any;
}

export default function Row(props: IRowProps): ReactElement {
  return (
    <Grid
      xl={props.widthInLargeScreen}
      lg={props.widthInLargeScreen}
      md={props.widthInLargeScreen}
      xs={12}
      sm={12}
      style={props.style}
      item
    >
      {props.children}
    </Grid>
  );
}
